<template>
						<div>
							<div class="tabbar" :class="{
								'tabbar-up': hasICP
							}">
								<div class="tabbar-item" :class="{active: currentPage == 'square'}" @click="onTabSelected('square')">
									<img v-if="currentPage == 'square'" src="http://litiresource.xcgogo.site/user/5980171/images/5073795bf420804eeaa006ae6a97ba4a.png">
									<img v-else src="http://litiresource.xcgogo.site/user/5980171/images/9d5af4f1ee567c147afb039a2dd9142b.png">
									<span>广场</span>
								</div>
								<div>
									<div class="tabbar-make" @click="onMakeTap">
										<img src="http://litiresource.xcgogo.site/user/5980171/images/6b4ea52f26bad4359957c570fd146a8b.png">
										<span>制作相册</span>
									</div>
								</div>
								<div class="tabbar-item" :class="{active: currentPage == 'mybook'}" @click="onTabSelected('mybook')">
									<img v-if="currentPage == 'mybook'" src="http://litiresource.xcgogo.site/user/5980171/images/1c68eb4cf0d4fa6795aef83f8b840d17.png">
									<img v-else src="http://litiresource.xcgogo.site/user/5980171/images/4f034e7ffad429005842f5c748e9351a.png">
									<span>我的相册</span>
								</div>
							</div>
							<div class="tabbar-icp" v-if="hasICP" @click="toICP">
								<div class="tabbar-icp_cont">
									<p>粤ICP备17119023号</p>
									<p>© Copyright © 2023.Company name All rights reserved.</p>
									<p>深圳市日天信息科技有限公司 版权所有</p>
								</div>
							</div>
							<make-by-wxsearch-toast
								v-model="makeToastShow"
								@confirm="onMakeToastConfirm">
							</make-by-wxsearch-toast>
						</div>
					</template>

					<script>
						import MakeByWxsearchToast from '@/components/st_comps/td_comp/comps/MakeByWxsearchToast.vue'

						export default {
							name: 'TabBar',
							components: {
								MakeByWxsearchToast
							},
							props: ['from'],
							data () {
								return {
									currentPage: '',
									makeToastShow: false
								};
							},
							computed: {
								hasICP () {
									return !this.$util.isEnv("wxa");
								}
							},
							watch: {
								from () {
									this.currentPage = this.from;
								}
							},
							created () {
								this.currentPage = this.from;
							},
							methods: {
								onTabSelected (page) {

									if (page == 'mybook' && (!this.$route.query['_source'] || !this.$route.query['openid'])) {
										if (!this.$util.isEnv("wx")) {
											alert("需使用微信登录功能，请在微信环境中打开")
											return;
										}
										window.location.href = "/vliti/login?target=mybook";
									} else {
										this.currentPage = page;
										this.$emit('onTabSelected', page);
									}
								},
								jumpTo (target) {
									if (target == this.from) {
										return;
									}
									this.$router.replace({path: target, query: {
										openid: this.$route.query.openid,
										_source: this.$route.query._source
									}})
								},
								onMakeTap () {

									if (this.from != 'menu') {
										this.$emit('onTabSelected', 'menu');
										return;
									}

									this.makeToastShow = true;
								},
								onMakeToastConfirm () {
									this.makeToastShow = false;
								},
								toICP () {
									window.location.href = "https://beian.miit.gov.cn/";
								}
							}
						}
					</script>

					<style scoped lang="less">
						.tabbar {
							position: fixed;
							width: 100%;
							height:@bw * 0.153;
							background: white;
							bottom: 0;
							left: 0;
							display: flex;
							border-top-left-radius:@bw * 0.011;
							border-top-right-radius:@bw * 0.011;
							z-index: 1000;
							span {
								margin-top:@bw * 0.003;
								font-size:@bw * 0.033;
								font-weight: bold;
								font-family: 'Heiti';
								color: #8a8888;
							}
						}
						.tabbar-item.active span {
							color: black;
						}
						.tabbar > div {
							position: relative;
							flex: 1;
						}
						.tabbar-item {
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;
							img {
								position: relative;
								width:@bw * 0.083;
								height:@bw * 0.083;
							}
						}
						.tabbar-make {
							position: absolute;
							top: -@bw * 0.028;
							left: 50%;
							margin-left: -@bw * 0.133;
							width:@bw * 0.267;
							height:@bw * 0.167;
							background: linear-gradient(to top right, #ff9761, #E72047);
							border-radius:@bw * 0.017;
							display: flex;
							flex-direction: column;
							justify-content: center;
							align-items: center;
							box-shadow: 0 0@bw * 0.029@bw * 0.008 rgba(169, 169, 169, 0.5);
							img {
								position: relative;
								width:@bw * 0.083;
								margin-bottom:@bw * 0.006;
								// height:@bw * 0.083;
							}
							span {
								color: #000000!important;
							}
						}
						.tabbar-up {
							bottom: 80px!important;
						}
						.tabbar-icp {
							position: fixed;
							width: 100%;
							height: 80px;
							background: #262626;
							color: rgba(255,255,255,.4);
							bottom: 0;
							left: 0;
							font-size: 15px;
							display: flex;
							align-items: center;
						}
						.tabbar-icp_cont {
							padding-left: 12px;
						}
					</style>
					<style>
						/* 提高弹窗层级，确保在 tabbar 之上 */
						.tabbar .st-toast {
							z-index: 10001 !important;
						}
						.tabbar .st-toast-confirm_overlay {
							z-index: 10001 !important;
						}
					</style>
